export default __webpack_public_path__ + "static/viinitie-banner-corporate-mobile.008bc303020db14c3515a6cd47f95347.jpg";